import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: 15em 0;

    .content-container {
        background-color: #FFFFFF;
        padding: 2em;

        .header {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            margin: 0 0 1.5rem 0;
            gap: 1em;

            .icon {
                width: 2em;
            }
            .headline {
                font-size: 1.2em;
                font-weight: 300;
                text-align: center;
            }
        }
    }

    @media all and (max-width: ${vars.mobileL}) {
        .content-container {
            max-width: 100%;
            width: 100%;
        }
    }
`;